import { gql } from "@apollo/client";

export const GET_RUN_OBSERVABILITY_DATA = gql`
  query GetRunObservabilityData($stackId: ID!, $runId: ID!) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        workerMetrics {
          states {
            runState
            failed
            errors {
              message
              resourceAddress
            }
            duration {
              seconds
              p95Seconds
              p95Ratio
              p95Severity
            }
            slowestResources {
              address
              resourceType
              durationSeconds
            }
            slowestHooks {
              command
              phase
              durationSeconds
            }
          }
          slowestProviders {
            address
            installDurationSeconds
          }
          duration {
            seconds
            p95Ratio
            p95Severity
          }
          failedResources {
            count
          }
          comparison {
            runCount
            requiredRunCount
            windowDays
          }
        }
        workerFindings {
          outcome {
            title
            description
            category
          }
          findings {
            type
            severity
            title
            description
            recommendation
          }
        }
      }
    }
  }
`;
